import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import { state } from '../state/state.service';
import { config } from './Home';
import { CalculationService } from '../services/calculation.services';
import { IOutageCalcResult } from '../types/railcarLoadingInterfaces';
import { OutageCalculationResults } from './OutageCalculationResults';

export const OUTAGE_PAGE_ROUTE = '/OutageCalc';

const schema = yup
  .object({
    carInitial: yup
      .string()
      .uppercase('Car initial should be in uppercase')
      .min(4, 'Must be exactly 4 characters')
      .max(4, 'Must be exactly 4 characters')
      .required(),
    carNumber: yup
      .number()
      .typeError('Car number must be a number')
      .positive()
      .integer()
      .required(),
    temp: yup
      .number()
      .typeError('Temperature must be a number')
      .positive()
      .integer()
      .required(),
  })
  .required();

export function OutageCalcPage(): JSX.Element {
  const [show, setShow] = useState(false);
  const [calculating, setCalculating] = useState(false);
  const [outageCalcResult, setOutageCalcResult] = useState<IOutageCalcResult>({
    Message: '',
  });
  const [outageCalcParams, setOutageCalcParams] = useState({
    CarInitial: '',
    CarNumber: 0,
    Temp: 0,
  });
  const [validationMessages, setValidationMessages] = useState<string[]>([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const resetValidationMessages = () => {
    setValidationMessages([]);
  };
  const calculateOutage = async () => {
    // event.preventDefault();
    setCalculating(true);
    const calculationService = new CalculationService(axios, config, state);
    const result = await calculationService.calculateOutage(
      outageCalcParams.CarInitial,
      outageCalcParams.CarNumber,
      outageCalcParams.Temp,
    );
    if (result) {
      setOutageCalcResult(result);
      setCalculating(false);
      setShow(true);
    }
  };

  const hideResultModal = () => {
    setShow(false);
  };
  const validationMessageList = validationMessages.length
    ? validationMessages.map((msg) => {
        return (
          <li className="text-danger text-center font-weight-bold small">
            {msg}
          </li>
        );
      })
    : null;
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
          <small className="font-italic font-weight-bold text-primary">
            Home
          </small>
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/Calulations' }}>
          <small className="font-italic font-weight-bold text-primary">
            Calculations
          </small>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          <small className="font-italic font-weight-bold text-gray">
            Outage Calculation
          </small>
        </Breadcrumb.Item>
      </Breadcrumb>
      <p className="font-weight-bold text-primary text-center mt-1">
        Calculate Rail Car Outage
      </p>
      {validationMessages.length > 0 && (
        <div className="d-flex justify-content-center ">
          <ul>{validationMessageList}</ul>
        </div>
      )}
      {calculating && (
        <div className="d-flex justify-content-center ">
          <Loader
            type="ThreeDots"
            color="#123966"
            height={50}
            width={60}
            timeout={5000} // 5 secs
          />
        </div>
      )}
      <div className="d-flex justify-content-center ">
        <div className="col-md-4">
          <form className="card p-1" onSubmit={handleSubmit(calculateOutage)}>
            <div className="form-group mb-0">
              <label
                htmlFor="carInitial"
                className="text-dark font-weight-bolder small"
              >
                Car Initial*
              </label>
              <input
                type="text"
                {...register('carInitial')}
                value={outageCalcParams.CarInitial || ''}
                onChange={(e) => {
                  setOutageCalcParams({
                    ...outageCalcParams,
                    CarInitial: e.target.value,
                  });
                  resetValidationMessages();
                }}
                className="form-control"
                id="carInitial"
              />
              <p className="text-danger small">{errors.carInitial?.message}</p>
            </div>
            <div className="form-group mb-0">
              <label
                htmlFor="carNumber"
                className="text-dark font-weight-bolder small"
              >
                Car Number*
              </label>
              <input
                type="number"
                {...register('carNumber')}
                value={outageCalcParams.CarNumber || ''}
                onChange={(e) => {
                  setOutageCalcParams({
                    ...outageCalcParams,
                    CarNumber: Number(e.target.value),
                  });
                  resetValidationMessages();
                }}
                className="form-control"
                id="carNumber"
              />
              <p className="text-danger small">{errors.carNumber?.message}</p>
            </div>
            <div className="form-group mb-0">
              <label
                htmlFor="temp"
                className="text-dark font-weight-bolder small"
              >
                NH3 Temp*
              </label>
              <input
                type="number"
                {...register('temp')}
                value={outageCalcParams.Temp || ''}
                onChange={(e) => {
                  setOutageCalcParams({
                    ...outageCalcParams,
                    Temp: Number(e.target.value),
                  });
                  resetValidationMessages();
                }}
                className="form-control"
                id="temp"
              />
              <p className="text-danger small">{errors.temp?.message}</p>
            </div>
            <div className="text-center">
              <button type="submit" className="btn btn-primary btn-sm">
                Calculate Outage
              </button>
            </div>
          </form>
          <OutageCalculationResults
            show={show}
            calcParams={outageCalcParams}
            calcResult={outageCalcResult}
            onClose={hideResultModal}
          />
        </div>
      </div>
    </>
  );
}
